import {
  CardTypeServiceClient
} from "@/proto/card_type_grpc_web_pb";
import { 
  CardType, 
  ListCardTypeRequest,
  ItemCardTypeRequest,
  CardTypeFilter,
  CardTypeSort,
  CardTypePagination,
  CreateCardTypeRequest,  
  UpdateCardTypeRequest, 
  DeleteCardTypeRequest
} from "@/proto/card_type_pb";
import {handleRefreshToken} from '@/main'

// Количество на странице по-умолчанию
const defaultLimit:number = 100;

export class CardTypeApi {
  items: Array<CardType> = [];
  client: CardTypeServiceClient;

  constructor() {
    const host:string = (window as any).VUE_APP_API_URL ?? '';
    this.client = new CardTypeServiceClient(host, null, null);
  }

  getAuth(){
    const metadata: any = {
      Authorization: localStorage.getItem('accessToken')
    }
    return metadata
  }

  // Установка и получение фильтров
  createFilter(data: any){

    const filter = new CardTypeFilter();
    const typeId:number = data.typeId !== undefined ? parseInt(data.typeId) : 0;
    const typeName:string = data.typeName !== undefined ? data.typeName.toString() : "";

    // Устанавливаем фильтры
    filter.setTypeId(typeId);
    filter.setTypeName(typeName);

    return filter;
  }

  // Установка и получение сортировки
  createSort(data: any){

    const sort = new CardTypeSort();
    const name:string = data.name !== undefined ? data.name.toString() : "type_name";
    const exp:string = data.exp !== undefined ? data.exp.toString() : "asc";

    // Устанавливаем параметры сортировки
    sort.setName(name);
    sort.setExp(exp);

    return sort;
  }

  // Установка и получение пагинации
  createPagination(data: any){

    const pagination = new CardTypePagination();
    const page:number = data.page !== undefined ? Number(data.page) : 1;
    const limit:number = data.limit !== undefined ? Number(data.limit) : defaultLimit;

    // Устанавливаем пагинацию
    pagination.setPage(page);
    pagination.setLimit(limit);
    pagination.setPages(0);

    return pagination;
  }

  // Список элементов
  getCardTypeItems(filter: any, sort: any, pagination: any){

    const request = new ListCardTypeRequest();
    
    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));
    request.setSort(this.createSort(sort));
    request.setPagination(this.createPagination(pagination));

    return new Promise((resolve, reject) => {
      this.client.listCardType(request, this.getAuth(), (err, message) => {
        if (err) {
          reject(err)
          handleRefreshToken()
        } else {
          resolve(message.getItemsList());
        }
      });
    });
  }

  // Получение элемента
  getCardTypeItem(filter: any){

    const request = new ItemCardTypeRequest();

    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));

    return new Promise((resolve, reject) => {
      this.client.itemCardType(request, this.getAuth(), (err, message) => {
        if (err) {
          reject(err)
          handleRefreshToken()
        } else {
          resolve(message.getItem());
        }
      });
    });
  }

  // Создание элемента
  createCardTypeItem(data: any){

    const request = new CreateCardTypeRequest();
    request.setTypeId(data.typeId);
    request.setTypeName(data.typeName);

    return new Promise((resolve, reject) => {
      this.client.createCardType(request, this.getAuth(), (err, message) => {
        if (err) {
          reject(err)
          handleRefreshToken()
        } else {
          resolve(message);
        }
      });
    });
  }

  // Редактирование элемента
  updateCardTypeItem(data: any){

    const request = new UpdateCardTypeRequest();
    request.setTypeId(data.typeId);
    request.setTypeName(data.typeName);

    return new Promise((resolve, reject) => {
      this.client.updateCardType(request, this.getAuth(), (err, message) => {
        if (err) {
          reject(err);
          handleRefreshToken()
        } else {
          resolve(message);
        }
      });
    });
  }

  // Удаление элемента
  deleteCardTypeItem(data: any){

    const request = new DeleteCardTypeRequest();
    request.setTypeId(data.typeId);

    return new Promise((resolve, reject) => {
      this.client.deleteCardType(request, this.getAuth(), (err, message) => {
        if (err) {
          reject(err);
          handleRefreshToken()
        } else {
          resolve(message);
        }
      });
    });
  }
}